import { render, staticRenderFns } from "./HonorNew.vue?vue&type=template&id=dd4fc7b8"
import script from "./HonorNew.vue?vue&type=script&lang=js"
export * from "./HonorNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports